import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "libox" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "content" }

import { formatToDate } from '@/utils/dateUtils';
import router from '@/router';


export default /*@__PURE__*/_defineComponent({
  __name: 'noticelist',
  props: {
  dataList: {
    type: Array,
    default: () => {}
  }
},
  setup(__props) {

const props = __props

// 查看文章
const checkDetail = (item: any) => {
  // sessionStorage.setItem('articleDetail', item);
  router.push({
    path: '/article',
    query: {
      id: item.id
    }
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.dataList, (item, i) => {
      return (_openBlock(), _createElementBlock("ul", { key: i }, [
        _createElementVNode("li", {
          onClick: ($event: any) => (checkDetail(item))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", null, _toDisplayString(item.title), 1),
            _createElementVNode("p", null, _toDisplayString(_unref(formatToDate)(item.publishDate)), 1)
          ])
        ], 8, _hoisted_2)
      ]))
    }), 128))
  ]))
}
}

})